import React from "react"
import { graphql, Link } from "gatsby"
import { Heading } from "@gorilla-technologies/customer-ui"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { Layout, Section, ProductList } from "../components"
import { Product } from "../types.d"

export type ProductsPageProps = {
  data: {
    allGorillaProduct: {
      nodes: Product[]
    }
  }
  pageContext: {
    currentPage: number
    numPages: number
  }
}

const ProductsPage = ({ data, pageContext }: ProductsPageProps) => {
  const { nodes: products } = data.allGorillaProduct
  const { currentPage, numPages } = pageContext

  return (
    <Layout title="All products">
      <Section width="large">
        <Heading level={1} align="center">
          All products
        </Heading>
      </Section>
      <Section width="large">
        <ProductList products={products} columns={4} />
      </Section>
      {numPages > 1 && (
        <Section width="large">
          <div className="flex items-center justify-center gap-2">
            {currentPage > 1 && (
              <Link to={`/products/${currentPage - 1}`}>
                <FaChevronLeft className="hover:text-brand-600 h-5 w-8 text-gray-900" />
              </Link>
            )}
            {Array.from({ length: numPages }).map((_, i) => (
              <Link
                key={i}
                to={`/products/${i + 1}`}
                className={`hover:text-brand-600 w-8 text-center text-lg font-medium leading-9 antialiased md:text-2xl ${
                  i + 1 === currentPage ? "text-brand-600" : "text-gray-900"
                }`}
              >
                {i + 1}
              </Link>
            ))}
            {currentPage < numPages && (
              <Link to={`/products/${currentPage + 1}`}>
                <FaChevronRight className="hover:text-brand-600 h-4 w-8 text-gray-900 md:h-5" />
              </Link>
            )}
          </div>
        </Section>
      )}
    </Layout>
  )
}

export const query = graphql`
  query productsQuery($skip: Int!, $limit: Int!) {
    allGorillaProduct(limit: $limit, skip: $skip) {
      nodes {
        title
        description
        productType
        id
        url
        price {
          inNear
        }
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: NONE, width: 320)
          }
        }
      }
    }
  }
`

export default ProductsPage
